import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowRight, faSignOut } from '@fortawesome/free-solid-svg-icons';
import './Navber.css';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../firebase.init';
import Loading from '../Loading';
import { signOut } from 'firebase/auth';
import useAdmin from '../../hooks/useAdmin';


const Navber = () => {

    const [user, loading] = useAuthState(auth);
    const [admin, setAdmin] = useAdmin(user);

    if (loading) {
        return <Loading />
    }

    const handleSignOut = () => {
        setAdmin(false)
        signOut(auth)
    }

    const desktopMenu = <>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#banner' rel="noreferrer">BANNER</a> </li>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#about' rel="noreferrer"> ABOUT ME </a></li>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#services' rel="noreferrer">SERVICES</a> </li>
        <li><a className='mr-1 text-md font-semibold' href='/home#products' rel="noreferrer">PROJECTS</a> </li>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#blogs' rel="noreferrer">BLOGS</a> </li>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#contact' rel="noreferrer">CONTACT ME</a> </li>
        {admin && <li><a className='mr-1 mb-1 text-md font-semibold' href="/secretdeshboard" rel="noreferrer">DESHBOARD</a></li>}
        <a className='mb-1' href="https://drive.google.com/file/d/1xuwhHCxnt8kwe5GHlOsY0jalDTGyd1K3/view?usp=sharing" target="_blank" rel='noreferrer'> <button className='btn  btn-md bg-green-500 text-sm border-0 text-white rounded-full ' >Download Resume <FontAwesomeIcon className='ml-2 ' icon={faCircleArrowRight} /></button></a>
        {user?.uid ? <button onClick={handleSignOut} className='btn  text-white border-0  ml-2 bg-green-500' > <FontAwesomeIcon icon={faSignOut} /> </button> : ''}
    </>
    const phoneMenu = <>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#banner'>BANNER</a> </li>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#about'> ABOUT ME </a> </li>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#services'   rel="noreferrer">SERVICES</a> </li>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#products'>PROJECTS</a> </li>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#blogs'>BLOGS</a> </li>
        <li><a className='mr-1 mb-1 text-md font-semibold' href='/home#contact'>CONTACT ME</a> </li>
        {admin && <li><a className='mr-1 mb-1 text-md font-semibold' href="/secretdeshboard">DESHBOARD</a></li>}
        <a className='mb-1' href="https://drive.google.com/file/d/1xuwhHCxnt8kwe5GHlOsY0jalDTGyd1K3/view?usp=sharing" target="_blank"> <button className='btn  btn-md bg-green-500 text-sm border-0 text-white rounded-full ' >Download Resume <FontAwesomeIcon className='ml-2 ' icon={faCircleArrowRight} /></button></a>
        {user?.uid ? <button onClick={handleSignOut} className='btn  text-white border-0  ml-2 bg-green-500'
        ><FontAwesomeIcon icon={faSignOut} /></button> : ''}

    </>

    return (
        <div className="navbar bg-base-100 sticky top-0 z-40  custom_shadow lg:px-20 md:10 py-3 ">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex="0" className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-6 h-6 stroke-current"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                    </label>
                    <ul tabIndex="0" className="menu menu-compact   dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        {phoneMenu}
                    </ul>
                </div>
                <div>
                    <Link to='/'><h2 className='logo_title text-2xl font-bold ml-2 md:ml-0 text-black'>Shakil<span className='text-green-500 '>Ahmed</span></h2></Link>
                </div>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal p-0">
                    {desktopMenu}
                </ul>
            </div>
            {admin && <div className='navbar-end lg:hidden '>
                <label htmlFor="deshboard_sidebar" className="btn btn-ghost drawer-button lg:hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                </label>
            </div>}
        </div>
    );
};

export default Navber;